import React from "react";
import PropTypes from "prop-types";
import "./style.scss";
import { injectIntl, FormattedMessage } from "react-intl";

import IconHexagon from "@learningblocks/exp-constants/lib/Icons/hexagon-solid";

class SummaryTextBase extends React.Component {
  render() {
    return (
      <div className={this.props.className} dir="auto">
        <h5 tabIndex={0}>
          <FormattedMessage
            id={this.props.heading}
            defaultMessage={this.props.heading}
          />
        </h5>
        <ul style={{ marginTop: this.props.heading ? 16 : 0 }}>
          {this.props.items.map((item, index) => {
            return (
              <li key={item + index}>
                <div className="index">
                  <IconHexagon style={{ fill: "#003E6B", height: "18px" }} />
                </div>
                <span tabIndex={0}>
                  <FormattedMessage id={item} defaultMessage={item} />
                </span>
              </li>
            );
          })}
        </ul>
      </div>
    );
  }
}
SummaryTextBase.propTypes = {
  type: PropTypes.string,
  content: PropTypes.array,
  items: PropTypes.array.isRequired,
  heading: PropTypes.string.isRequired,
  className: PropTypes.string,
};

SummaryTextBase.defaultProps = {
  className: "summaryText",
};

export const SummaryText = injectIntl(SummaryTextBase);
